import React from 'react';
import { PropTypes } from 'prop-types';
import { Card, CardHeader } from 'common/Card';
import { useTimelineEvents } from 'common/hooks';
import EnrollmentTimelineEvent from './EnrollmentTimelineEvent';

const EnrollmentTimelineEventsCard = ({ enrollmentRequestId }) => {
  const timelineEvents = useTimelineEvents('enrollment_request', enrollmentRequestId);

  return (
    <Card className="mt-3 bg-white" data-testid="enrollment-request-timeline-history">
      <CardHeader className="pt-2 space-y-2" title="History" />
      <div className="mt-4 max-w-3xl grid grid-cols-12 gap-4">
        <div className="col-span-3 font-heavy-font text-text-blue text-14px">Status Updates:</div>
        <div className="col-span-9 pb-4">
          <ul className="pl-0 list-unstyled mb-0">
            {timelineEvents.map((timelineEvent) => (
              <EnrollmentTimelineEvent
                key={timelineEvent.id}
                timelineEvent={timelineEvent}
              />
            ))}
          </ul>
        </div>
      </div>
    </Card>
  );
};

EnrollmentTimelineEventsCard.propTypes = {
  enrollmentRequestId: PropTypes.string.isRequired,
};

export default EnrollmentTimelineEventsCard;
